export interface ToolSEO {
  title: string;
  description: string;
  keywords: string;
}

export const toolsSEO: Record<string, ToolSEO> = {
  'json-formatter': {
    title: 'JSON Formatter & Validator',
    description: 'Format, validate và beautify JSON online miễn phí. Hỗ trợ tự động sửa lỗi JSON, minify, và export sang Excel. Công cụ JSON formatter tốt nhất cho developer.',
    keywords: 'json formatter, json validator, json beautifier, json minify, format json online, validate json, json to excel, công cụ json'
  },
  'jwt-decoder': {
    title: 'JWT Decoder & Analyzer',
    description: 'Decode và phân tích JWT token online. Xem header, payload, và verify signature của JWT. Công cụ miễn phí cho developer làm việc với JSON Web Token.',
    keywords: 'jwt decoder, jwt analyzer, decode jwt, jwt token, json web token, jwt validator, jwt debugger'
  },
  'base64': {
    title: 'Base64 Encoder & Decoder',
    description: 'Encode và decode Base64 online miễn phí. Chuyển đổi text sang Base64 và ngược lại. Nhanh chóng, an toàn, không lưu trữ dữ liệu.',
    keywords: 'base64 encoder, base64 decoder, encode base64, decode base64, base64 converter, base64 tool'
  },
  'xml-formatter': {
    title: 'XML Formatter & Beautifier',
    description: 'Format và beautify XML documents online. Minify XML, validate cú pháp, và tổ chức code XML dễ đọc hơn. Công cụ XML miễn phí.',
    keywords: 'xml formatter, xml beautifier, xml validator, format xml, xml minify, xml pretty print'
  },
  'url-encoder': {
    title: 'URL Encoder & Decoder',
    description: 'Encode và decode URL, query string online. Chuyển đổi ký tự đặc biệt trong URL an toàn. Component encoder cho developer.',
    keywords: 'url encoder, url decoder, encode url, decode url, url encode online, query string encoder'
  },
  'hash-generator': {
    title: 'Hash Generator - MD5, SHA1, SHA256',
    description: 'Tạo hash online với MD5, SHA-1, SHA-256, SHA-512. Hash generator miễn phí cho mã hóa và verify checksum. Nhanh và bảo mật.',
    keywords: 'hash generator, md5 generator, sha256 generator, sha1, checksum calculator, hash online, mã hóa hash'
  },
  'qr-generator': {
    title: 'QR Code Generator',
    description: 'Tạo QR code miễn phí từ text, URL, số điện thoại. Download QR code PNG, customize kích thước. QR code generator nhanh nhất.',
    keywords: 'qr code generator, tạo qr code, qr generator, qr code maker, qr code free, generate qr code'
  },
  'color-picker': {
    title: 'Color Picker & Converter',
    description: 'Chuyển đổi màu giữa HEX, RGB, HSL. Color picker online với preview trực quan. Tool thiết yếu cho web designer và developer.',
    keywords: 'color picker, color converter, hex to rgb, rgb to hex, hsl color, color tool, chọn màu'
  },
  'regex-tester': {
    title: 'Regex Tester & Debugger',
    description: 'Test và debug regular expressions online. Highlight matches, explain regex pattern. Regex tester miễn phí với real-time testing.',
    keywords: 'regex tester, regex debugger, test regex, regular expression tester, regex validator, regex online'
  },
  'uuid-generator': {
    title: 'UUID Generator v1, v4, v5',
    description: 'Generate UUID/GUID online với version 1, 4, 5. Tạo unique identifier cho database, API. UUID generator nhanh và tin cậy.',
    keywords: 'uuid generator, guid generator, uuid v4, unique id generator, generate uuid, uuid online'
  },
  'base64-image': {
    title: 'Base64 Image Converter',
    description: 'Convert hình ảnh sang Base64 và ngược lại. Upload ảnh hoặc paste Base64 string. Image to Base64 converter miễn phí.',
    keywords: 'base64 image, image to base64, base64 to image, convert image base64, base64 encoder image'
  },
  'timestamp-converter': {
    title: 'Unix Timestamp Converter',
    description: 'Chuyển đổi Unix timestamp sang date time và ngược lại. Hỗ trợ milliseconds, ISO 8601, readable format. Timestamp converter chính xác.',
    keywords: 'timestamp converter, unix timestamp, epoch converter, timestamp to date, date to timestamp'
  },
  'url-analyzer': {
    title: 'URL Parser & Analyzer',
    description: 'Phân tích và parse URL thành các component: protocol, host, path, query params. URL analyzer chi tiết cho developer.',
    keywords: 'url analyzer, url parser, parse url, url breakdown, url decoder, query string parser'
  },
  'text-diff-checker': {
    title: 'Text Diff Checker & Compare',
    description: 'So sánh 2 đoạn text và highlight sự khác biệt. Text diff tool online với character-by-character comparison. Miễn phí.',
    keywords: 'text diff, diff checker, compare text, text comparison, diff tool, text compare online'
  },
  'case-converter': {
    title: 'Text Case Converter',
    description: 'Chuyển đổi text case: camelCase, snake_case, PascalCase, kebab-case, UPPER, lower. Case converter cho developer.',
    keywords: 'case converter, text case, camelcase, snake case, pascal case, kebab case, convert case'
  },
  'text-statistics': {
    title: 'Text Statistics & Word Counter',
    description: 'Đếm từ, ký tự, câu, đoạn văn. Tính reading time và phân tích chi tiết văn bản. Text analyzer miễn phí.',
    keywords: 'word counter, character counter, text statistics, count words, text analyzer, reading time'
  },
  'json-path-tester': {
    title: 'JSONPath Tester & Evaluator',
    description: 'Test và evaluate JSONPath expressions online. Query JSON data dễ dàng. JSONPath tester với syntax highlighting.',
    keywords: 'jsonpath tester, json path, json query, jsonpath evaluator, test jsonpath online'
  },
  'lorem-ipsum-generator': {
    title: 'Lorem Ipsum Generator',
    description: 'Tạo lorem ipsum text placeholder cho design và mockup. Hỗ trợ nhiều styles: classic, bacon, cat, hipster, pirate, Vietnamese. Generator đa dạng nhất.',
    keywords: 'lorem ipsum generator, placeholder text, dummy text, lorem generator, text generator, mockup text'
  }
};
